import React from "react";
import ReactDOM from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import App from "./pages/App.jsx";
import { ToastProvider } from './components/ToastProvider.jsx';
import { initFrontendSentry, Sentry } from './sentry.js';
import "./styles.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
const toastDurationMs = Number(import.meta.env.VITE_TOAST_DURATION_MS || 5000);

initFrontendSentry();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={publishableKey}
      signInForceRedirectUrl="/dashboard"
      signUpForceRedirectUrl="/dashboard"
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
      afterSignOutUrl="/dashboard"
    >
      <Sentry.ErrorBoundary fallback={<div style={{ padding: 24 }}>Ocurrió un error inesperado.</div>}>
        <ToastProvider defaultDuration={toastDurationMs}>
          <App />
        </ToastProvider>
      </Sentry.ErrorBoundary>
    </ClerkProvider>
  </React.StrictMode>
);
